import { Logout, Settings } from "@mui/icons-material";
import { Avatar, IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useContext, useState } from "react";
import AuthContext from "../../services/authContext";
import { NavbarDiv } from "./style";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(false);
  const open = Boolean(anchorEl);
  const { auth, logout } = useContext(AuthContext)

  return (
    <NavbarDiv>
      <div className="wrapper">
        <div className="header">
          <span>
            Assisted Sales Balancer B2C
          </span>
        </div>
        {auth.status === 'OK' && <ul>
          <li>
            <span>Last Login: {auth.dateTime}</span>
          </li>
          <li>
            {/* <button onClick={() => setOpen(true)}>Test</button> */}
            <IconButton
              onClick={(e) => {
                auth.status === 'OK' && setAnchorEl(e.currentTarget);
              }}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <Avatar sx={{ width: 32, height: 32 }}>{auth.email && auth.email[0].toUpperCase()}</Avatar>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={() => {
                setAnchorEl(null);
              }}
              onClick={() => {
                setAnchorEl(null);
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              <Link style={{textDecoration: "none", color: "#000000DE"}} to="/newweb/changepass">
                  <MenuItem>
                    <ListItemIcon>
                      <Settings fontSize="small" />
                    </ListItemIcon>
                    Change password
                  </MenuItem>
                </Link>
              <MenuItem onClick={logout}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </li>
        </ul>}
      </div>
      <hr />
    </NavbarDiv>
  )
}

export default Navbar